import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../../hooks/useApiCallHooks";
import PageHeading from "../../../../../components/admin/common/PageHeading";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AddGallery = () => {
    const navigate=useNavigate();
   const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    case_study_id: "",
    image: [], 
  });
  const [imagePreview, setImagePreview] = useState([]);

  // Fetch case studies for dropdown
  useEffect(() => {
    callAPI("get", "admin/case-studies");
  }, []);

  useEffect(() => {
    if (response?.data) {
      setData(response.data);
    }
  }, [response]);

  // Handle Multiple Image Upload
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Add new files instead of replacing
    const newImages = [...formData.image, ...files];

    setFormData({ ...formData, image: newImages });
    setImagePreview([
      ...imagePreview,
      ...files.map((file) => URL.createObjectURL(file)),
    ]);
  };

  // Remove selected image before submit
  const handleRemoveImage = (index) => {
    const updatedImages = [...formData.image];
    const updatedPreview = [...imagePreview];
    updatedImages.splice(index, 1);
    updatedPreview.splice(index, 1);

    setFormData({ ...formData, image: updatedImages });
    setImagePreview(updatedPreview);
  };

  // Handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const submitData = new FormData();
    submitData.append("case_study_id", formData.case_study_id);

    // Backend expects "image[]"
    formData.image.forEach((file) => {
      submitData.append("image[]", file);
    });

    callAPI("post", "admin/case-studie-images", submitData);
  };
 useEffect(() => {
    if ( statusCode === 201) {
      toast.success("Images added successfully!");
      setTimeout(() => {
        navigate('/gallery/list');
      }, 1000);
    }
  }, [response, statusCode, navigate]);
  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container mt-5">
          <PageHeading title="Add Case Study" subTitle="Fill out the details" />

          <div className="container card p-4 shadow-sm mt-3">
            <form
              onSubmit={handleSubmit}
              className="row g-3"
              encType="multipart/form-data"
            >
              <h6>Add Case Study Form</h6>

              {/* Dropdown - Case Study */}
              <div className="col-md-6 col-12">
                <label className="form-label">Select Case Study</label>
                <select
                  className="form-select"
                  value={formData.case_study_id}
                  onChange={(e) =>
                    setFormData({ ...formData, case_study_id: e.target.value })
                  }
                >
                  <option value="">-- Select Case Study --</option>
                  {data?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.case_study_id}
                </span>
              </div>

              {/* Multiple Images Upload */}
              <div className="col-md-6 col-12">
                <label className="form-label">Upload Images</label>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  className="form-control"
                  onChange={handleImageChange}
                />

                {/* Responsive preview gallery */}
                <div className="row mt-3 g-2">
                  {imagePreview.map((src, index) => (
                    <div
                      key={index}
                      className="col-6 col-md-4 col-lg-3 position-relative"
                    >
                      <img
                        src={src}
                        alt="Preview"
                        className="img-fluid rounded border"
                        style={{
                          height: "120px",
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                      {/* Remove button */}
                      <button
                        type="button"
                        className="btn btn-sm btn-danger position-absolute top-0 end-0"
                        onClick={() => handleRemoveImage(index)}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>

                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.image}
                </span>
              </div>

              {/* Submit Button */}
              <div className="col-12 col-md-4 mt-4 mb-3">
                <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default AddGallery;
